module.exports = __webpack_public_path__ + "static/media/WeddingService.39541bb1.png";